module.exports = __webpack_public_path__ + "img/icon-dapp-flyover.65857340.svg";